"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.L1_NODE_ANCESTOR_NUMBER = void 0;
exports.L1_NODE_ANCESTOR_NUMBER = 1;
